module.exports = __webpack_public_path__ + "img/appLogo-color--Onlight.eadf98a3.svg";